<template>
  <div id="app">
    <Header />
    <transition name="fade">
      <router-view class="app-container"/>
    </transition>
    <Footer />
  </div>
</template>

<script>
import Header from './components/Header'
import Footer from './components/Footer'

export default {
  components: {
    Header,
    Footer,
  },
  head: {
    title: {
      inner: 'OriginalFake Photography | 2020 | Paris - FRANCE'
    },
    meta: [
      { name: 'application-name', content: 'OriginalFake Photography' },
      // ...
      // Twitter
      { name: 'twitter:title', content: 'OriginalFake Photography | 2020 | Paris - FRANCE' },
      // with shorthand
      { n: 'twitter:description', c: 'OriginalFake Photography'},
      // ...
      // Google+ / Schema.org
      { itemprop: 'name', content: 'OriginalFake Photography' },
      { itemprop: 'description', content: 'OriginalFake Photography' },
      // ...
      // Facebook / Open Graph
      { property: 'og:title', content: 'OriginalFake Photography' },
      { property: 'og:description', content: 'OriginalFake Photography' },
    ],
  }
}
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
}

html, body {
  font-size: $font-size;
  color: $black;
  background-color: $white; 
  font-family: 'Libre Franklin', ;
  font-weight: 300;
} 

p, li {
  font-size: 0.8rem;
  letter-spacing: 0.02rem;
  line-height: 1.2rem;
}

ul {
  padding-left: 1rem;
}

a {
  @extend %link;
}

.app-container {
  min-height: 100vh;
  overflow-x: hidden;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 500ms $ease-out;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

@media screen and (max-width: $tablet) {
  html, body {
    font-size: $font-size * 0.75;
  }
}

@media screen and (max-width: $mobile) {
  html, body {
    font-size: $font-size * 0.6;
  }
}
</style>